import { LockIcon, UnlockIcon } from '@chakra-ui/icons'
import { Button, HStack, Tooltip, VStack } from '@chakra-ui/react'
import React from 'react'
import { useDoorData } from './context/DoorContext'

function EmergencyButtonsAllips() {

  const { openAllIPs, closeAllIPs } = useDoorData()

  return (
    <VStack spacing={4} gridRow={'2'} alignItems={'center'} justifyContent={'center'}>
      <HStack >
        <Tooltip hasArrow label='Atrakinamos durys visam laikui' fontSize='md'>
          <Button
          margin={'0!important'}
          borderRadius={'1rem 0 0 1rem'} 
          p={'1.6rem'}
          bg='green.700'
          color={'#fff'}
          _hover={{bg:'green.600'}}
           size={'lg'} onClick={() => { openAllIPs() }} leftIcon={<UnlockIcon />} >Atrakinti visas duris</Button>
        </Tooltip>
        <Tooltip hasArrow label='Atstatomos durys į pradinę būseną' fontSize='md'>
          <Button
          margin={'0!important'}
          borderRadius={'0rem 1rem 1rem 0'} 
          p={'1.6rem'}
          bg='red.500'
               color={'#fff'}
               _hover={{bg:'red.600'}} 
               size={'lg'} onClick={() => { closeAllIPs() }} leftIcon={<LockIcon />} >Užrakinti visas duris</Button>
        </Tooltip>
      </HStack>
    </VStack>
  )
}

export default EmergencyButtonsAllips